<app-toast />

<section class="painel-comissoes">
    <div class="painel-dashboard-layout">
        <aside class="painel-acoes-laterais">
            <app-card-content headingLevel="h1" title="Reuniões" subtitle="Navegação da agenda" icon="pi pi-calendar-clock" [border]="false">
                <div class="acoes-cabecalho">
                    <button type="button" pButton icon="pi pi-calendar-clock" label="Próxima Reunião" [disabled]="!proximaReuniao" (click)="irParaProximaReuniao()"></button>
                    <!--
                        "Voltar na agenda" e não "Reunião anterior": a consulta desta tela cobre só
                        a agenda à frente, então o botão nunca alcança uma reunião passada — e o
                        estado vazio orienta a usar o Acompanhamento justamente para isso.
                    -->
                    <button
                        type="button"
                        pButton
                        icon="pi pi-arrow-left"
                        label="Voltar na agenda"
                        title="Volta para a reunião anterior dentro da agenda carregada"
                        severity="secondary"
                        [outlined]="true"
                        [disabled]="!reuniaoAnterior"
                        (click)="irParaReuniaoAnterior()"
                    ></button>
                    <button type="button" pButton icon="pi pi-refresh" label="Atualizar" severity="secondary" [outlined]="true" [loading]="carregando" (click)="carregarDashboard()"></button>
                </div>
            </app-card-content>
        </aside>

        <div class="painel-conteudo">
            @if (carregando) {
                <section class="card-reuniao-atual skeleton skeleton-card"></section>
                <app-composicao-membros-comissoes class="membros-dashboard" [carregando]="true" titulo="Membros da comissão" subtitulo="Carregando composição"></app-composicao-membros-comissoes>
            } @else if (reuniaoAtual; as reuniao) {
                <app-card-content class="card-reuniao-atual" [border]="false" [icon]="'pi pi-calendar-clock'" [title]="'#' + reuniao.codigo">
                    <span card-subtitle class="status-texto" [ngClass]="classeStatus(reuniao.status)">{{ rotuloStatus(reuniao.status) }}</span>
                    <div card-header class="topo-card">
                        <app-send-whatsapp #sendWhatsapp [text]="gerarMensagemWhatsappReuniao(reuniao)" [abrirDialog]="true" style="display: none"></app-send-whatsapp>
                        <app-botao-acoes label="Opções" [iconPos]="EInconPos.LEFT" [items]="itensAcoesReuniaoAtual()" [iconColumns]="3"></app-botao-acoes>
                    </div>

                    <div class="conteudo-principal">
                        <div class="bloco-titulo">
                            <h2 class="nome-comissao-destaque">{{ reuniao.nomeComissao }}</h2>
                            <div class="linha-data">
                                <i class="pi pi-clock"></i>
                                <span>{{ formatarDataHora(reuniao.dataInicio) }}</span>
                                <strong>{{ formatarDistancia(reuniao.dataInicio) }}</strong>
                            </div>
                        </div>
                    </div>

                    <section class="reuniao-secao">
                        <div class="secao-cabecalho">
                            <span class="secao-icone"><i class="pi pi-info-circle"></i></span>
                            <div>
                                <h3>Informações da reunião</h3>
                                <p>Dados principais para acompanhamento e compartilhamento.</p>
                            </div>
                        </div>

                        <div class="detalhes">
                            <div class="detalhe">
                                <i class="pi pi-globe detalhe-icon"></i>
                                <div class="detalhe-info">
                                    <span>Visível Portal</span>
                                    <strong [ngClass]="classeVisivelPortal(reuniao)">{{ rotuloVisivelPortal(reuniao) }}</strong>
                                </div>
                            </div>
                            <div class="detalhe">
                                <i class="pi pi-clock detalhe-icon"></i>
                                <div class="detalhe-info">
                                    <span>Horário</span>
                                    <strong>{{ formatarPeriodo(reuniao) }}</strong>
                                </div>
                            </div>
                            <div class="detalhe">
                                <i class="pi pi-map-marker detalhe-icon"></i>
                                <div class="detalhe-info">
                                    <span>Local</span>
                                    <strong>{{ reuniao.local || '-' }}</strong>
                                </div>
                            </div>
                            <div class="detalhe">
                                <i class="pi pi-desktop detalhe-icon"></i>
                                <div class="detalhe-info">
                                    <span>Modalidade</span>
                                    <strong [ngClass]="classeModalidade(reuniao)">{{ reuniao.modalidade || '-' }}</strong>
                                </div>
                            </div>
                            <div class="detalhe">
                                <i class="pi pi-briefcase detalhe-icon"></i>
                                <div class="detalhe-info">
                                    <span>Atividades</span>
                                    <strong [ngClass]="classeAtividades(reuniao)">{{ rotuloAtividades(reuniao) }}</strong>
                                </div>
                            </div>
                            <div class="detalhe">
                                <i class="pi pi-users detalhe-icon"></i>
                                <div class="detalhe-info">
                                    <span>Confirmações</span>
                                    <strong>{{ resumoConfirmacoes(reuniao) }}</strong>
                                </div>
                            </div>
                            <div class="detalhe">
                                <i class="pi pi-file-edit detalhe-icon"></i>
                                <div class="detalhe-info">
                                    <span>Status da ata</span>
                                    <strong [ngClass]="classeStatusAta(reuniao)">{{ reuniao.statusAta || '-' }}</strong>
                                </div>
                            </div>
                            <div class="detalhe">
                                <i class="pi pi-id-card detalhe-icon"></i>
                                <div class="detalhe-info">
                                    <span>Protocolo</span>
                                    <strong>{{ reuniao.protocolo || '-' }}</strong>
                                </div>
                            </div>
                        </div>
                    </section>
                </app-card-content>

                <app-composicao-membros-comissoes
                    class="membros-dashboard"
                    [membros]="membrosReuniaoAtual"
                    [carregando]="carregandoMembros"
                    [reuniao]="reuniao"
                    titulo="Membros da comissão"
                    [subtitulo]="reuniao.nomeComissao"
                ></app-composicao-membros-comissoes>
            } @else {
                <section class="estado-vazio">
                    <i class="pi pi-calendar-times"></i>
                    <div>
                        <strong>Nenhuma reunião futura encontrada.</strong>
                        <span>Use o acompanhamento para consultar períodos anteriores ou filtros específicos.</span>
                    </div>
                    <button type="button" pButton icon="pi pi-list" label="Acompanhamento" (click)="abrirAcompanhamentoGeral()"></button>
                </section>
            }
        </div>
    </div>
</section>
